module.exports = __webpack_public_path__ + "img/fullscreen_bg.61caf2fd.png";